import { type TagContentTypeEnumEnum } from '@/shared/api'

export const TagContentTypeEnum = {
  Music: 1 as TagContentTypeEnumEnum,
  Podcast: 2 as TagContentTypeEnumEnum,
  AudioBook: 3 as TagContentTypeEnumEnum,
  Album: 4 as TagContentTypeEnumEnum,
  Mood: 5 as TagContentTypeEnumEnum,
} as const

export const tagTypeUrlParamsMap: Record<
  string,
  TagContentTypeEnum | undefined
> = {
  music: TagContentTypeEnum.Music,
  podcast: TagContentTypeEnum.Podcast,
  audiobook: TagContentTypeEnum.AudioBook,
  album: TagContentTypeEnum.Album,
  mood: TagContentTypeEnum.Mood,
}

export type TagContentTypeEnum =
  (typeof TagContentTypeEnum)[keyof typeof TagContentTypeEnum]

export const tagContentTypeArray = Object.values(TagContentTypeEnum)

export const getTagContentTypeString = (type: TagContentTypeEnum) => {
  switch (type) {
    case TagContentTypeEnum.Music:
      return 'Музыка'
    case TagContentTypeEnum.Podcast:
      return 'Подкаст'
    case TagContentTypeEnum.AudioBook:
      return 'Аудиокнига'
    case TagContentTypeEnum.Album:
      return 'Альбом'
    case TagContentTypeEnum.Mood:
      return 'Настроение'
    default:
      return 'Неизвестный тип'
  }
}
